import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export interface DocumentDetails {
  ID: string;
  doctype: string;
  filename: string;
  hash: string;
  [key: string]: any;
}

export interface DocumentQueryParams {
  [key: string]: string | number | boolean;
}

export interface DownloadDocumentResponse {
  [key: string]: any;
}

const REGISTRY_API_URL = process.env.REACT_APP_REGISTRY_API_URL || "";

export const registryDocumentApi = createApi({
  reducerPath: "registrydocumentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: REGISTRY_API_URL,
  }),
  tagTypes: ["RegistryDocument"],
  endpoints: (build) => ({
    getRegistryDocumentDetails: build.query<DocumentDetails[], DocumentQueryParams>({
      query: (params) => {
        return {
          url: "/rs/registry/document/publicdocuments",
          params: params,
          method: "GET",
        };
      },
      providesTags: ["RegistryDocument"],
    }),
    downloadDocument: build.query<DownloadDocumentResponse, string>({
      query: (dochash) => `/rs/registry/registrydocument/${dochash}`,
      providesTags: ["RegistryDocument"],
    }),
  }),
});

export const { useGetRegistryDocumentDetailsQuery, useDownloadDocumentQuery } = registryDocumentApi;
